var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-2"},[_c('span',[_vm._v(" "+_vm._s(_vm.oferta.quantidade)+" "+_vm._s(_vm.oferta.unidadeMedida.descricao)+" x ")]),_vm._v(" "+_vm._s(_vm._f("currency")(_vm.oferta.precoUnitario))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }